(function(){
  // Find all c1t sections with zoom enabled
  var sections = document.querySelectorAll('.ha-c1t.has-zoomfx');
  if(!sections.length) return;

  // Respect reduced motion
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(prefersReduced) return;

  sections.forEach(function(section){
    if(section.dataset.zoomfxInit === '1') return;
    section.dataset.zoomfxInit = '1';

    var img = section.querySelector('.c1t__img');
    if(!img) return;

    // One-time play when it becomes visible
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;

        if(img.dataset.zoomfxPlayed === '1'){ io.unobserve(img); return; }

        img.dataset.zoomfxPlayed = '1';
        img.classList.add('zoomfx-enter');

        img.addEventListener('animationend', function(){
          img.classList.remove('zoomfx-enter');
        }, { once: true });

        io.unobserve(img);
      });
    }, { threshold: [0, 0.25] });

    io.observe(img);
  });
})();